<template>
  <div
    class="project-structure-taktarea-wrapper"
    >
    <slot name="header">
      <div class="project-structure-taktarea-wrapper-header">
        <v-btn icon
          @click="$emit('closeTaktareaWrapper')"
          style="height: 24px; width: 24px"
          >
          <v-icon
            style="cursor: pointer"
            >
            {{!wrapper_open?'keyboard_arrow_right':'keyboard_arrow_down'}}
          </v-icon>
        </v-btn>
        <div>{{wrapper_name}}</div>
      </div>
    </slot>
    <div
      v-if="wrapper_open"
      class="project-structure-taktarea-wrapper-content"
      :style="wrapper_name?'margin-left: 24px':''"
      >
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['wrapper_name', 'wrapper_open'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-taktarea-wrapper {
  }
  .project-structure-taktarea-wrapper-header {
    display: flex;
    white-space: nowrap;
  }
  .project-structure-taktarea-wrapper-content {
  }
</style>
